module.exports = __webpack_public_path__ + "2ab3834d60f9dd592680bb9b91c7e35d.svg";